interface CustomWindow extends Window {
  dataLayer?: Array<any>;
}

declare let window: CustomWindow;

export const mainPushEventDataLayer = (data: any[] | Record<string, any>) => {
  window.dataLayer = window.dataLayer || [];
  Array.isArray(data) ? handlerPushAnArray(data) : handlerPushAnObject(data);
};

const handlerPushAnObject = (data: Record<string, any>) => {
  const layerPush = {
    ...data,
  };
  window.dataLayer.push(layerPush);
};

const handlerPushAnArray = (data: any[]) => {
  const layerPush = [...data];
  window.dataLayer = window.dataLayer.concat(layerPush);
};
